"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const RoutingDisabler_1 = require("./RoutingDisabler");
let RoutingDisablerService = class RoutingDisablerService {
    constructor(_router) {
        this._router = _router;
        this._locks = new Array();
        this._disabler = null;
    }
    get isDisabled() {
        return this._disabler !== null;
    }
    disable(lockId) {
        if (!this._disabler) {
            this._disabler = new RoutingDisabler_1.RoutingDisabler(this._router);
        }
        if (this._locks.indexOf(lockId) < 0) {
            this._locks.push(lockId);
        }
    }
    enable(lockId) {
        let idx = this._locks.indexOf(lockId);
        if (idx >= 0) {
            this._locks.splice(idx, 1);
            if (this._locks.length == 0) {
                this._disabler.reEnable();
                this._disabler = null;
            }
        }
    }
};
RoutingDisablerService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [router_1.Router])
], RoutingDisablerService);
exports.RoutingDisablerService = RoutingDisablerService;
